<script>
  import { onMount, createEventDispatcher } from "svelte";
  let dispatch = createEventDispatcher();
  import { UserStore, UserName } from "./store.js";

  onMount(async function() {
    if ($UserStore.registerUser == null && !$UserName)
      dispatch("pageChange", "/register/start");

    $UserStore.registerUser = null;
  });
</script>

<form action="" class="box">
  <h1 class="title is-4">Account Created Successfully</h1>
  <p>
    Your username is
    <strong>{$UserName}</strong>
    <br /> <br />
    We have sent you an email to <strong>validate your email address. </strong>
    Please click on the link in this email to complete your account's creation before attempting to log into the website.
  </p>
  <div style="text-align: right; margin-top: 15px;">
    <a href="/signin/{$UserName}/" class="button is-purple">Login to eAdmissions</a>
  </div>

  <p style="margin-top: 30px;">
    To help confirm your identity, if you forget your password and it needs to
    be reset, please configure your security questions.
  </p>

  <div style="text-align: right; margin-top: 15px;">
    <a href="/register/securityquestion" class="button is-primary">Setup Security Questions</a>

  </div>
</form>
